import { render } from "./AccountTypeSelect.vue?vue&type=template&id=8f4e59d6"
import script from "./AccountTypeSelect.vue?vue&type=script&lang=js"
export * from "./AccountTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__